/** Целочисленная математика боя: никаких дробей в состоянии, только целые (MADR 0002, contracts/common). */
import { type Direction, PERMILLE } from "@newfungame/contracts";

/** Целая часть `a / b` с отбрасыванием к нулю. */
export function divTrunc(a: number, b: number): number {
  return Math.trunc(a / b);
}

/** `v · p / 1000` с отбрасыванием дробной части. */
export function mulPermille(v: number, p: number): number {
  return Math.trunc((v * p) / PERMILLE);
}

/** Целый квадратный корень (вниз), точный для любых целых до 2^53. */
export function isqrt(n: number): number {
  if (n <= 0) return 0;
  let r = Math.floor(Math.sqrt(n));
  while (r * r > n) r--;
  while ((r + 1) * (r + 1) <= n) r++;
  return r;
}

/** Квадрат расстояния между точками. */
export function dist2(ax: number, ay: number, bx: number, by: number): number {
  const dx = bx - ax;
  const dy = by - ay;
  return dx * dx + dy * dy;
}

/** tan(22,5°) в промилле — граница секторов при выборе направления. */
const TAN_22_5 = 414;

/** Направление взгляда по вектору (8 секторов, без тригонометрии): `n` — +y, `e` — +x. */
export function facingOf(dx: number, dy: number): Direction {
  const ax = Math.abs(dx);
  const ay = Math.abs(dy);
  if (ax === 0 && ay === 0) return "s";
  if (ay * PERMILLE <= ax * TAN_22_5) return dx > 0 ? "e" : "w";
  if (ax * PERMILLE <= ay * TAN_22_5) return dy > 0 ? "n" : "s";
  if (dy > 0) return dx > 0 ? "ne" : "nw";
  return dx > 0 ? "se" : "sw";
}
